import React from "react";
import { Trans } from "@coworker/locales";
import { RECONNECT_DELAY_MS } from "../../core/hooks/useOnline";
import { FixaToast } from "@coworker/apprestructured/src/shared/wrappers/FixaToast/FixaToast.js";

export const OfflineBar = ({ isReconnecting }) => {
  const [reconnectSeconds, setReconnectSeconds] = React.useState(null);
  const [toastOpen, setToastOpen] = React.useState(true);

  // store the interval id (or null when not running)
  const intervalRef = React.useRef(null);

  // Clear helper that is stable across renders
  const clearIntervalIfAny = React.useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, []);

  React.useEffect(() => {
    if (isReconnecting) {
      const start = Math.max(Math.floor(RECONNECT_DELAY_MS / 1000), 1);
      setReconnectSeconds(start);
      clearIntervalIfAny();

      intervalRef.current = setInterval(() => {
        setReconnectSeconds((prev) => {
          const current = typeof prev === "number" ? prev : start;
          const next = Math.max(current - 1, 0);
          if (next === 0) clearIntervalIfAny();
          return next;
        });
      }, 1000);
    } else {
      clearIntervalIfAny();
      setReconnectSeconds(null);
    }
    return () => clearIntervalIfAny();
  }, [isReconnecting, clearIntervalIfAny]);

  // Optional: if the user closes the toast, also stop the timer so it doesn’t run in the background
  const handleClose = React.useCallback(() => {
    setToastOpen(false);
    clearIntervalIfAny();
  }, [clearIntervalIfAny]);

  return (
    <FixaToast
      isOpen={toastOpen}
      onCloseRequest={handleClose}
      text={
        <Trans values={{ seconds: reconnectSeconds ?? "" }}>
          {isReconnecting ? "attemptingToReconnectString" : "offlineModeString"}
        </Trans>
      }
    />
  );
};
